import { format, getTime, UTCDate } from '@/utils/dates';
import { InvoiceEvidenceView } from '../../types/entity-types';
import { isValidDate } from './get-linked-data';

const TODAY = format(new UTCDate(), 'yyyy-MM-dd');

type GetEvidenceInvoiceDateRangeParams = {
  evidence?: InvoiceEvidenceView[];
};

export const getEvidenceInvoiceDateRange = ({ evidence }: GetEvidenceInvoiceDateRangeParams) => {
  if (!evidence || evidence.length === 0) {
    // If there are no evidence, we should still return a start and end date to avoid issues with the data-provider
    return {
      startDate: TODAY,
      endDate: TODAY,
    };
  }

  // Filter out evidence without an invoice date
  // Sorted by oldest evidence first
  const sortedEvidence = evidence
    .filter(hasInvoiceDate)
    .filter(isValidDate)
    .sort((a, b) => getTime(a.billingDates.invoiceDate) - getTime(b.billingDates?.invoiceDate));

  if (sortedEvidence.length === 0) {
    return {
      startDate: TODAY,
      endDate: TODAY,
    };
  }

  const startDate = format(new UTCDate(sortedEvidence[0].billingDates.invoiceDate), 'yyyy-MM-dd');

  return {
    startDate,
    endDate: TODAY,
  };
};

const hasInvoiceDate = (
  evidence: InvoiceEvidenceView,
): evidence is InvoiceEvidenceView & { billingDates: { invoiceDate: string } } => {
  return !!evidence.billingDates?.invoiceDate;
};
